<template>
  <div>
    <div
      class="modal fade"
      id="itemGroup"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header" style="border-bottom: unset">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-7 col-12 pl-md-5 pr-md-5">
                <div class="row">
                  <div class="col-md-12 mb-3">
                    <h5 class="text-uppercase">Maak informatiegroep</h5>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <div class="row mt-3 ml-2">
                        <div class="col-lg-6">
                          <input
                            v-model="create_itemgroup.active"
                            id="activeevent"
                            class="form-check-input ml-1 mt-1"
                            type="checkbox"
                            value=""
                          />
                          <label for="activeevent" class="ml-4">Actief</label>
                        </div>
                        <div class="col-lg-6">
                          <input
                            v-model="create_itemgroup.public"
                            id="publicevent"
                            class="form-check-input ml-1 mt-1"
                            type="checkbox"
                            value=""
                          />
                          <label for="publicevent" class="ml-4">Publiek</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">Naam</label>
                      <input
                        v-model="create_itemgroup.name"
                        type="text"
                        class="form-control"
                        id="name"
                      />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="textarea1">Omschrijving</label>
                      <editor
                        id="textarea1"
                        v-model="create_itemgroup.description"
                        :init="{
                          height: 200,
                          menubar: false,
                          language: 'nl',
                          plugins: [
                            'advlist autolink lists link image charmap print preview anchor',
                            'searchreplace visualblocks code fullscreen',
                            'insertdatetime media table paste code help wordcount',
                          ],
                          toolbar:
                            'undo redo | formatselect | bold italic backcolor | \
                                                            alignleft aligncenter alignright alignjustify | \
                                                            bullist numlist outdent indent | removeformat | help',
                        }"
                      />
                    </div>
                  </div>

                  <!-- <div class="col-md-12">

                                        <div v-for="(file,index) in tasks_files" :key="index" class="row">
                                            <div class="col-lg-1">
                                                <img src="/assets/img/attach_blue.svg"
                                                     alt="">
                                            </div>
                                            <div class="col-lg-7">
                                                <label style="color: #4192D9">{{file.filename}}</label>
                                            </div>
                                            <div class="col-lg-3">
                                                <a @click="removeTaskFile(index)" href="javascript:void(0)"><i class="fa fa-trash" style="color: red;" aria-hidden="true"></i></a>
                                            </div> 
                                        </div> 

                                    </div> -->
                  <!-- <div class="col-md-12">
                                        <input type="file" class="d-none" @change="addTaskFile()" id="task_file">
                                        <button class="btn-dark float-right"><label for="task_file">Attach file/s</label></button>
                                    </div> -->
                </div>
              </div>
              <div class="col-md-5 col-12 pl-md-2 pr-md-5">
                <div class="row">
                  <div class="col-md-12 col-12 mb-3 p-0">
                    Commissies
                  </div>
                  <div class="col-md-12 col-12 pb-4">
                    <Multiselect
                      searchable
                      mode="tags"
                      v-model="create_itemgroup.selected_committees"
                      :options="committees"
                    />
                  </div>
                  <!-- <div class="col-md-12 col-12 pl-md-5 pt-4 pb-4 container-bg">
                                        <div class="row">
                                            <div class="col-md-10 custom-scrollbar" style="height: 200px;">
                                                <div v-for="(comt,index) in committees" :key="index" class="form-check  ">
                                                    <input @click="notify()" v-model="comt.selected" class="form-check-input" type="checkbox" value=""  :id="'checkcomt_'+comt.id">
                                                    <label class="form-check-label" :for="'checkcomt_'+comt.id">
                                                        {{comt.title}}
                                                    </label>
                                                </div> 
                                            </div>
                                        </div>
                                    </div> -->
                </div>

                <div class="row">
                  <div class="col-12 mb-3 p-0">
                    Leden
                  </div>
                  <div class="col-12">
                    <label for="">
                      <input
                        type="checkbox"
                        v-model="create_itemgroup.select_all_users"
                        id=""
                      />
                      Alle leden
                    </label>
                  </div>
                  <div
                    class="col-12 pb-4"
                    v-if="!create_itemgroup.select_all_users"
                  >
                    <Multiselect
                      searchable
                      mode="tags"
                      v-model="create_itemgroup.selected_users"
                      :options="members"
                    />
                  </div>
                  <!-- <div class="col-md-12 col-12 pl-md-5 pt-4 pb-4 container-bg">
                    <div class="row">
                      <div
                        class="col-md-10 custom-scrollbar"
                        style="height: 200px;"
                      >
                        <div
                          v-for="(comt, index) in members"
                          :key="index"
                          class="form-check  "
                        >
                          <input
                            v-model="comt.selected"
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            :id="'checkcomt_' + comt.id"
                          />
                          <label
                            class="form-check-label"
                            :for="'checkcomt_' + comt.id"
                          >
                            {{ comt.lastname + " " + comt.firstname }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div> -->
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-lg-12">
                <button
                  @click="createItemgroup()"
                  class="btn-dark float-right mt-3"
                >
                  Opslaan
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    committees: {
      type: Array,
      default: () => [],
    },
    members: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      create_itemgroup: { active: false, public: false, parent_id: 0 },
    };
  },
  computed: {
    ...mapState({
      itemgroup_parent_id: (state) => state.itemgroup_parent_id,
    }),
  },
  methods: {
    createItemgroup() {
      var itemgroup = {
        title: this.create_itemgroup.name,
        body: this.create_itemgroup.description,
        active: this.create_itemgroup.active,
        public: this.create_itemgroup.public,
        parent_id: this.itemgroup_parent_id,
        selected_committees: this.create_itemgroup.selected_committees,
        selected_users: this.create_itemgroup.selected_users,
        select_all_users: this.create_itemgroup.select_all_users,
      };

      this.$store
        .dispatch("post", {
          endpoint: "api/v1/itemgroups",
          details: itemgroup,
        })
        .then((data) => {
          window.location.reload();
          console.log(data);
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
  },
};
</script>
